import { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import "./Mockquestion.css";
import Sidebar from "../Components/Sidebar";
import { useEffect } from "react";
import ResultModal from "../Components/ResultModal";
function Mockquestion() {
  const { state } = useLocation();
  const { questions, mock_id } = state;
  const [currentIndex, setCurrentIndex] = useState(() => {
    const savedIndex = localStorage.getItem("mockCurrentIndex");
    return savedIndex ? parseInt(savedIndex, 10) : 0;
  });
  useEffect(() => {
    localStorage.setItem("mockCurrentIndex", currentIndex);
  }, [currentIndex]);
  const [showModal, setShowModal] = useState(false);
  const [score, setScore] = useState(null);
  const [passmark, setPassmark] = useState(35);

  const lang = localStorage.getItem("lang") || "en"; // Get language
  const jwtToken = localStorage.getItem("jwtToken");

  // Initialize answers with -1
  const [answers, setAnswers] = useState(
    questions.reduce((acc, question) => {
      acc[question.question_id] = -1;
      return acc;
    }, {})
  );

  const handleOptionClick = (optionIndex) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questions[currentIndex].question_id]: optionIndex,
    }));
  };

  const handleNext = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevIndex) => prevIndex - 1);
    }
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        mock_id: mock_id,
        answers: answers,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/submit_mock`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );

      const result = response.data;
      if (!result.error) {
        setScore(result.data.score);
        setPassmark(result.data.passmark);
        setShowModal(true);
      } else {
        alert(`Error: ${result.msg}`);
      }
    } catch (error) {
      console.error("Error submitting answers:", error);
      alert("Failed to submit answers. Please try again.");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    window.location.href = "/mocktest";
  };

  const currentQuestion = questions[currentIndex];

  return (
    <div className="overview">
      <Sidebar />
      <div style={{ height: "auto" }} className="question-wrapper">
        <div className="progress-container">
          <div
            className="progress-bar"
            style={{
              width: `${((currentIndex + 1) / questions.length) * 100}%`,
            }}
          ></div>
          <div className="progress-text">
            {lang === "bn"
              ? `Question ${currentIndex + 1} / ${questions.length}`
              : `Question ${currentIndex + 1} of ${questions.length}`}
          </div>
        </div>
        <div key={currentQuestion.question_id} className="question-content">
          <div className="image-column">
            {currentQuestion.image && (
              <img
                src={currentQuestion.image}
                className="question-image"
                alt="Question"
              />
            )}
            <div className="question-text">
              {currentIndex + 1}. {currentQuestion.question_text}
              {lang === "bn" && (
                <div className="question-text-bn">
                  {currentQuestion.question_text_bangla}
                </div>
              )}
            </div>
          </div>

          <div className="options-grid">
            {[0, 1, 2, 3].map((index) => {
              const en = currentQuestion[`option_${index + 1}`];
              const bn = currentQuestion[`option_${index + 1}_bangla`];

              return (
                <div
                  key={index}
                  className={`option ${
                    answers[currentQuestion.question_id] === index
                      ? "selected"
                      : ""
                  }`}
                  onClick={() => handleOptionClick(index)}
                >
                  {en}
                  {lang === "bn" && <div className="option-bn">{bn}</div>}
                </div>
              );
            })}
          </div>

          <div className="nav-buttons">
            <button onClick={handlePrevious} disabled={currentIndex === 0}>
              {lang === "bn" ? "পেছনে" : "Previous"}
            </button>

            <button
              onClick={handleNext}
              disabled={currentIndex === questions.length - 1}
            >
              {lang === "bn" ? "পরবর্তী" : "Next"}
            </button>
          </div>
        </div>

        <button onClick={handleSubmit} className="submit-button">
          {lang === "bn" ? "উত্তর জমা দিন" : "Submit Mock Answers"}
        </button>
      </div>

      {showModal && (
        <ResultModal
          showModal={showModal}
          passmark={passmark}
          onClose={closeModal}
          testType={lang === "bn" ? "মক পরীক্ষা" : "Mock Test"}
          score={score * 100}
          fullMark={50}
          lang={lang}
        />
      )}
    </div>
  );
}

export default Mockquestion;
